import React from 'react'

export const PriorityContext = React.createContext(false)

export const PrioritizedContent: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
	<PriorityContext.Provider value={true}>{children}</PriorityContext.Provider>
)
